import { Component, HostBinding, Input, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { AlertModel } from '@libs/common/models';
import { IconComponent } from '@libs/components/icons';
import { IconName } from '@libs/shared/models';
import { ThemeColorName } from '@libs/themes';

@Component({
  selector: 'ui-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButtonModule, MatCardModule, IconComponent],
})
export class AlertComponent implements AlertModel, OnChanges {
  @Input() public alert?: AlertModel;
  @Input() public message: string = '';
  @Input() public showIconInfo: boolean = true;
  @Input() public linkLabel?: string = '';
  @Input() public linkHref?: string = '';
  @Input() public linkTarget?: string = '';
  @Input() public mode: 'color' | 'light' = 'color';
  @Input() @HostBinding('class') public theme?: ThemeColorName;

  public ngOnChanges(): void {
    if (!this.alert) {
      return;
    }

    this.message = this.alert.message;
    this.showIconInfo = this.alert.showIconInfo ?? this.showIconInfo;
    this.linkLabel = this.alert.linkLabel;
    this.linkHref = this.alert.linkHref;
    this.linkTarget = this.alert.linkTarget;
    this.theme = this.alert.theme;
  }

  public getIcon(): IconName | undefined {
    if (!this.showIconInfo || !this.theme) {
      return;
    }

    const themeIconMap: Partial<Record<ThemeColorName, IconName>> = {
      success: 'circle-check',
      error: 'circle-xmark',
      warning: 'triangle-exclamation',
      info: 'circle-info',
    };

    return themeIconMap[this.theme];
  }
}
